import * as yup from 'yup';

const dateRegex = /(^(((0[1-9]|1[0-9]|2[0-8])[/](0[1-9]|1[012]))|((29|30|31)[/](0[13578]|1[02]))|((29|30)[/](0[4,6,9]|11)))[/](19|[2-9][0-9])\d\d$)|(^29[/]02[/](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/;
const cpfRegex = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
const cnpjRegex = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;
const phoneRegex = /^\(\d{2}\) \d{4,5}-\d{4}$/;
const zipCodeRegex = /^\d{5}-\d{3}$/;

yup.addMethod(yup.string, 'date', function () {
  return this.test('date', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (field && dateRegex.test(field.value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid date' }));
      }
    });
  });
});

yup.addMethod(yup.string, 'cpf', function () {
  return this.test('cpf', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (field && cpfRegex.test(field.value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid CPF', type: 'cpf' }));
      }
    });
  });
});

yup.addMethod(yup.string, 'cnpj', function () {
  return this.test('cnpj', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (field && cnpjRegex.test(field.value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid CNPJ', type: 'cnpj' }));
      }
    });
  });
});

yup.addMethod(yup.string, 'phone', function () {
  return this.test('phone', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (field && phoneRegex.test(field.value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid phone', type: 'phone' }));
      }
    });
  });
});

yup.addMethod(yup.string, 'zipCode', function () {
  return this.test('zipCode', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (field && zipCodeRegex.test(field.value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid CEP', type: 'zipCode' }));
      }
    });
  });
});

yup.addMethod(yup.string, 'rg', function () {
  return this.test('rg', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (field && field.value.trim()) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid RG', type: 'rg' }));
      }
    });
  });
});

const schema = yup.object().shape({
  type: yup
    .string()
    .required()
    .trim(),
  name: yup
    .string()
    .required()
    .trim(),
  socialName: yup
    .string()
    .required()
    .trim(),
  email: yup.string().when({
    is: () => {
      const email = document.getElementById('email');
      return email && !!email.value.trim().length;
    },
    then: yup
      .string()
      .email()
      .trim()
  }),
  gender: yup.string().when('type', {
    is: value => value === '1',
    then: yup
      .string()
      .required()
      .trim()
  }),
  born: yup.string().date(),
  cpf: yup.string().when('type', {
    is: value => value === '1',
    then: yup.string().cpf()
  }),
  cnpj: yup.string().when('type', {
    is: value => value === '2',
    then: yup.string().cnpj()
  }),
  rg: yup.string().when('type', {
    is: value => {
      const rg = document.getElementById('rg');
      return value === '1' && rg && !!rg.value.trim().length;
    },
    then: yup.string().rg()
  }),
  ie: yup.string().when('type', {
    is: value => {
      const ie = document.getElementById('ie');
      return value === '1' && ie && !!ie.value.trim().length;
    },
    then: yup
      .string()
      .required()
      .trim()
  }),
  main: yup.string().phone(),
  message: yup.string().when({
    is: () => {
      const msg = document.getElementById('message');
      return msg && !!msg.value.trim().length;
    },
    then: yup
      .string()
      .phone()
      .trim()
  }),
  street: yup
    .string()
    .required()
    .trim(),
  number: yup
    .string()
    .required()
    .trim(),
  zipCode: yup.string().zipCode()
});

export default schema;
